<template>
  <footer
    :class="page"
    :style="{ marginBottom: countdownHeight }"
  >
    <!-- <div
      v-if="phase !== 'vote' && page !== 'vote'"
      ref="countdown"
      class="countdown"
    >
      <div class="container">
        <div class="text">
          <font-awesome-icon :icon="['fas', 'check-to-slot']" />
          Voting starts in
        </div>
        <CountdownTimer
          class="countdown-timer"
          date="2024-02-26T00:00:00-05:00"
        />
      </div>
    </div> -->

    <div class="container top">
      <nuxt-link
        to="/"
        class="logo"
      >
        <img
          :src="logoSrc"
          alt="Retool Your School"
        >
      </nuxt-link>

      <nav class="desktop-menu">
        <ul>
          <li
            v-for="menuItem of footerNav"
            :key="menuItem.id"
          >
            <nuxt-link
              :to="menuItem.url"
              class=""
            >
              {{ menuItem.title }}
            </nuxt-link>
          </li>
        </ul>
      </nav>

      <nav class="mobile-menu">
        Follow Us
        <ul class="social-links">
          <li
            v-for="menuItem of socialLinks"
            :key="menuItem.id"
          >
            <a
              :href="menuItem.url"
              class=""
              :aria-label="menuItem.title"
            >
              <font-awesome-icon :icon="['fab', menuItem.acf.icon.id]" />
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <hr>

    <div class="container bottom">
      <div>
        <span
          role="img"
          aria-label="Copyright"
        >
          ©
        </span>
        {{ year }} Home Depot.
        <br class="mobile-br">
        All Rights Reserved.
      </div>
      <div>
        Use of this site is subject to certain
        <a
          href="https://www.homedepot.com/c/Terms_of_Use"
          target="_blank"
        >
          Terms Of Use
        </a>
      </div>
    </div>

    <nuxt-link
      to="/vote"
      class="vote-btn btn"
    >
      Vote Now
    </nuxt-link>

    <img
      src="https://ds.reson8.com/insights.gif?rand=[cache_buster]&evkey=101159817"
      alt=""
      width="1"
      height="1"
      border="0"
    >
  </footer>
</template>

<script>
import logoSrc from '@/assets/imgs/logo.png';
import trophy from '@/assets/imgs/trophy.svg';
import RysEmbedModal from '@/components/modals/EmbedModal.vue';

export default {
  async setup() {
    const modal = useModal();
    const wpJson = useWp();
    const menuStore = useMenuStore();

    const { data: options } = await useAsyncData(
      'footer-options',
      () => wpJson.options.get(['video_embed', 'form_content', 'disclaimer', 'form_image'])
    );

    return {
      modal,
      wpJson,
      menuStore,
      embed: options.value.video_embed,
      formContent: options.value.form_content,
      disclaimer: options.value.disclaimer,
      formImage: options.value.form_image
    };
  },

  data() {
    return {
      logoSrc,
      trophy,
      countdownHeight: 0
    };
  },

  computed: {
    phase() {
      return this.$config.phase;
    },

    footerNav() {
      return this.menuStore.footerNav;
    },

    socialLinks() {
      return this.menuStore.socialLinks;
    },

    year() {
      return new Date().getFullYear();
    },

    page() {
      return this.$route.name;
    },

    opts() {
      return this.embed;
    }
  },

  watch: {
    $route: {
      deep: true,
      handler() {
        setTimeout(() => {
          this.updateCountdownHeight();
        }, 0);
      }
    }
  },

  mounted() {
    this.updateCountdownHeight();
    window.addEventListener('resize', this.updateCountdownHeight);

    if (!window.localStorage.getItem('hasVisited')) {
      if (this.$route.path === '/') {
        // Homepage: show video embed
        this.showEmbedModal(this.embed || null, false);
      }
      else {
        // Other pages: show form
        this.showEmbedModal(null, true);
      }
      window.localStorage.setItem('hasVisited', 'true');
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateCountdownHeight);
  },

  methods: {
    updateCountdownHeight() {
      const countdown = this.$refs.countdown;

      if (countdown) {
        this.countdownHeight = `${countdown.clientHeight}px`;
      }
      else {
        this.countdownHeight = 0;
      }
    },

    showEmbedModal(html, showForm = false) { // Updated to accept an optional showForm flag
      this.modal(RysEmbedModal, this, {
        props: {
          embed: showForm ? null : html,
          showForm,
          formContent: showForm ? this.formContent : null,
          disclaimer: showForm ? this.disclaimer : null,
          formImage: showForm ? this.formImage?.url : null // New: Pass image URL only when showing the form
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  color: $thd-white;
  background: $thd-black;
  margin-bottom: -18px;

  .countdown {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    color: $thd-white;
    background: $thd-black;
    z-index: 999;
    padding: 12px 0 14px;

    img {
      display: none;

      @media screen and (min-width: $breakpoint-lg) {
        display: inline-block;
      }
    }

    .container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .text {
        width: 100%;
        font-stretch: condensed;
        font-size: 14px;
        line-height: 14px;
        text-transform: uppercase;
        font-weight: 700;
        text-align: center;
        margin-bottom: 12px;

        @media screen and (min-width: $breakpoint-lg) {
          width: 50%;
          font-size: 28px;
          line-height: 28px;
          margin-bottom: 12px;
        }
      }

      .countdown-timer {
        width: 100%;

        @media screen and (min-width: $breakpoint-lg) {
          width: 50%;
        }
      }
    }
  }

  .top {
    padding-top: 32px;
    padding-bottom: 32px;
    display: flex;
    justify-content: space-between;

    @media screen and (min-width: $breakpoint-lg) {
      padding-top: 60px;
      padding-bottom: 60px;
    }

    .logo {
      display: block;
      width: 164px;
      flex: none;

      > img {
        width: 100%;
      }
    }

    nav.desktop-menu {
      flex: 1 1 auto;
      display: none;
      justify-content: center;

      @media screen and (min-width: $breakpoint-lg) {
        display: flex;
      }

      ul {
        padding: 0;
        margin: 0;
        display: grid;
        grid-auto-flow: column dense;
        grid-template-rows: repeat(3, minmax(0, 1fr));
        gap: 8px 120px;

        li {
          list-style: none;

          a {
            color: inherit;
            font-size: 16px;
            font-weight: 700;
            line-height: 24px;
            text-decoration: none;

            &:visited {
              color: inherit;
            }

            &:hover {
              color: $thd-orange;
            }
          }
        }
      }
    }

    nav.mobile-menu {
      margin-left: 40px;

      @media screen and (min-width: $breakpoint-lg) {
        display: none;
      }

      ul {
        padding: 0;
        margin: 0;
        margin-top: 12px;
        display: flex;

        li {
          list-style: none;

          &:not(:first-child) {
            margin-left: 20px;
          }

          a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 32px;
            height: 32px;
            background: $thd-white;
            color: $thd-black;
            border-radius: 9999px;
          }
        }
      }
    }
  }

  hr {
    border-color: $thd-dark-gray;
  }

  .bottom {
    color: $thd-off-white;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    padding: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: $breakpoint-lg) {
      text-align: left;
      flex-direction: row;
      justify-content: space-between;
    }

    a {
      color: inherit;

      &:visited {
        color: inherit;
      }
    }

    .mobile-br {
      @media screen and (min-width: $breakpoint-lg) {
        display: none;
      }
    }
  }

  .vote-btn {
    display: none;
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: auto;
    z-index: 1;

    @media screen and (min-width: $breakpoint-lg) {
      display: none;
    }

    &:hover {
      background: $thd-black;
      color: $thd-white;
      border-color: $thd-white;
    }
  }

  &.vote .vote-btn {
    display: none;
  }

  &.vote {
    z-index: 5 !important;
  }
}
</style>
